export default function cloudflareStreamUrl(videoId) {
  return `https://videodelivery.net/${videoId}/manifest/video.m3u8`
}
